import { Redirect } from 'react-router-dom'

const IndexRoute = () => (
    <Redirect to="/process" />
)

export default IndexRoute
